/*
 * Restricts the text input to be numerical characters only (only works with input of type text)
 * Supports decimal numbers if you assign the directive attribute a value of "decimal". Example: wow-numeric="decimal"
 */
module.exports = function () {
    return {
        restrict: 'A',
        require: '?ngModel',
        link(scope, element, attrs, ngModelCtrl) {
            let last = '';
            ngModelCtrl.$parsers.push(function (val) {
                if (!val) {
                    val = '';
                }
                let clean = '';
                if (attrs.olyNumeric === 'decimal') {
                    clean = val.replace(/[^0-9\.]+/g, '');
                    if (clean.indexOf('.') !== clean.lastIndexOf('.')) {
                        if (clean.lastIndexOf('.') === clean.length - 1) {
                            clean = clean.substring(-1, clean.length - 1);
                        } else {
                            // If we get here they tried to paste a number in that made it invalid (multiple decimal points) so revert it to the old value
                            clean = last;
                        }
                    }
                } else {
                    clean = val.replace(/[^0-9]+/g, '');
                }
                if (val !== clean) {
                    ngModelCtrl.$setViewValue(clean);
                    ngModelCtrl.$render();
                }
                last = clean;
                return clean;
            });

        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/numeric/numeric-directive.js
 **/